import React from 'react';
import {FormattedMessage} from 'react-intl';
import {Modal} from 'components/modals';

const EmployeeWelcomeModal = ({frequency, isOpen, onCancel}) => {
  return (
    <Modal isOpen={isOpen} onHide={onCancel} size='md' title='Welcome email to employees'>
      <div className='border px3 py2 bg-haze rounded'>
        <div className='h4 py1'>
          <FormattedMessage id='performance.Hi (Employee Name),'/>
        </div>
        <div className='h4 py1'>
          <FormattedMessage id='performance.EMPLOYEE_PERFORMANCE_WELCOME_MESSAGE' values={{frequency: frequency}} />
        </div>
      </div>
    </Modal>
  );
};

export default EmployeeWelcomeModal;
